import routes from './router'
import Router from 'vue-router'
import {get} from './api/index'
import {formatRoutes,loadView} from './utils/index'
const createRouter = () => new Router({
	routes,
})
let isMenus = false;
const router = createRouter();
router.beforeEach(async(to, from, next) => {
	var white_list = ['/template','/login','/agreement','/cockpit'];
	let token = sessionStorage.getItem('token');
	if(white_list.indexOf(to.path) != -1){
		next();
	}else if(!token){
		next({path: '/login' })
	}else if(to.path == '/'){
		next({path: '/index' })
	}else{
		if(!isMenus&&token){
			isMenus =true;
			var {data} = await get('index/getMenuList',{}, false);
			var menu_list = [];
			for(var i = 0; i<data.length; i++){
				menu_list.push(...data[i].children);
			}
			sessionStorage.setItem('menu_list', JSON.stringify(menu_list));
			sessionStorage.setItem('menu', JSON.stringify(data));
			var list=formatRoutes(data);
			router.addRoute({path: '/', name: '', component:loadView('Home'), children: list});
			next({...to, replace:true});
		}else{
			next();
		}
	}
})

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err);
};
export default router


// WEBPACK FOOTER //
// ./src/permission.js